import { money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const FetchLineOfCreditPaymentDetails = gql`
  fragment AccountDetailSelectorFragment on AccountDetailForSelector {
    __typename
    accountId
    accountNumber
    accountNumberLast4
    iconURL
    name
    nickname
    availableBalance {
      ...money
    }
  }
  ${money}

  fragment LineOfCreditPaymentViewFragment on LineOfCreditPaymentView {
    __typename
    dueDate
    lineOfCreditId
    outstandingBalance {
      ...money
    }
    prepopulatedPaymentAmount {
      ...money
    }
  }
  ${money}

  query VaroLineOfCreditPaymentDetails {
    lineOfCreditManualPaymentDetails {
      ... on LineOfCreditPaymentDetailError {
        __typename
        code
        message
        title
      }
      ... on LineOfCreditPaymentDetailSuccess {
        __typename
        fromAccountSelectorView {
          ...AccountDetailSelectorFragment
        }
        lineOfCreditPaymentView {
          ...LineOfCreditPaymentViewFragment
        }
      }
    }
  }
`;

export default FetchLineOfCreditPaymentDetails;
